import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Desenvolvido por WSSoft 2018 v1.2.43 atualizado por GetPush Tecnologia em: 04/10/2024</span>
  `,
})
export class FooterComponent {
}
